/**
 * Sheet Selector Component
 * Dropdown for selecting a sheet from multi-sheet Excel files
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/core/components/ui/select';
import { Label } from '@/core/components/ui/label';
import { LegacyExcelSheetMappings, ApplicationTypeLabels } from '../../types/translation-types';

interface SheetSelectorProps {
  sheets: string[];
  value: string | null;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

export function SheetSelector({
  sheets,
  value,
  onChange,
  disabled = false,
  className = '',
}: SheetSelectorProps) {
  return (
    <div className={`space-y-2 ${className}`}>
      <Label>Select Sheet</Label>
      <Select
        value={value || ''}
        onValueChange={onChange}
        disabled={disabled}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select a sheet to import" />
        </SelectTrigger>
        <SelectContent>
          {sheets.map((sheet) => {
            const mappedAppType = LegacyExcelSheetMappings[sheet];
            const appTypeName = mappedAppType ? ApplicationTypeLabels[mappedAppType] : null;

            return (
              <SelectItem key={sheet} value={sheet}>
                <div className="flex flex-col">
                  <span>{sheet}</span>
                  {appTypeName && (
                    <span className="text-xs text-muted-foreground">
                      → {appTypeName}
                    </span>
                  )}
                </div>
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
      <p className="text-xs text-muted-foreground">
        This Excel file contains multiple sheets. Select which sheet to import.
      </p>
    </div>
  );
}
